<template>
    <div class="sheetSearchModal">
        <Drawer
            v-model="showModal"
            class="sheetSearchModal-drawer"
            width="400"
            :title="'筛选'"
            :mask-closable="true"
            :closable="true"
            :draggable="true"
        >
            <div class="sheetSearchModal-drawer-body">
                <div class="sheetSearchModal-drawer-body-title">高级搜索</div>
                <dsh-advSearch-form
                    :value="advSearchData"
                    :formList="formList"
                    :initData="initData"
                    :initSearchFields="initSearchFields"
                    @change="change"
                ></dsh-advSearch-form>

                <dsh-buttons
                    class="sheetSearchModal-drawer-body-btns"
                    itemClass="sheetSearchModal-drawer-body-btns-item"
                    :list="$getOperationList(['reset', 'search'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
            </div>
        </Drawer>
    </div>
</template>

<script>
    export default {
        name: "sheetSearchModal",
        props: {
            // 此处value是 modal的显示不显示
            value: Boolean,

            formList: {
                type: Array,
                default () {
                    return [];
                }
            },
            initSearchFields: {
                type: Array,
                default () {
                    return [];
                }
            },
            initData: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                advSearchData: {
                    logic: "and",
                    conditions: []
                },

                operationMap: {
                    reset: {
                        name: "重 置",
                        type: "reset",
                        size: "small",
                        event: "reset"
                    },
                    search: {
                        name: "确 定",
                        type: "search",
                        btnType: "primary",
                        size: "small",
                        event: "closeModal"
                    }
                }
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {},

            // 点击重置
            reset () {
                this.advSearchData = {
                    logic: "and",
                    conditions: []
                };
                this.search();
            },
            // 控件change回调事件
            change (searchParams, ...params) {
                this.$emit("change", searchParams, ...params);
                this.search();
            },

            // 点击筛选
            search () {
                this.$emit("search", this.advSearchData);
            },

            closeModal () {
                this.showModal = false;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/operation/sheetSearchModal.vue